import { useQuery } from "@tanstack/react-query";
import { getCashAgentUrl } from "@/lib/runtime-config";

export type CashDriverStatusOk = {
  ok: true;
  status: {
    device: string;
    plugged_in: boolean;
    setup: unknown;
    levels: unknown;
    error: string | null;
  };
};

export type CashDriverStatusErr = {
  ok: false;
  error: string;
};

export type CashDriverStatusResult = CashDriverStatusOk | CashDriverStatusErr;

export type PrinterDiagnosticStatus = {
  Code: number;
  Message: string;
  HasError: boolean;
};

export type PrinterDiagnostic = {
  Status: string;
  PaperPresent: boolean;
  CoverClosed: boolean;
  PaperNearEnd?: boolean;
  Printer?: PrinterDiagnosticStatus;
  Offline?: PrinterDiagnosticStatus;
  Error?: PrinterDiagnosticStatus;
  PaperRoll?: PrinterDiagnosticStatus;
};

export type PrinterEventDetails = {
  LastOccurred: number;
  LastDiff: number;
  Event: string;
  Data: number;
  Message: string;
  OverallCount: number;
  CountSinceNotified: number;
  CountSinceDriverRestart: number;
  Notified: number;
};

export type PrinterStatusOk = {
  ok: true;
  status: {
    Success: boolean;
    Description: string;
    Timestamp: number;
    Diagnostic?: PrinterDiagnostic;
    Events?: Record<string, PrinterEventDetails>;
  };
};

export type PrinterStatusErr = {
  ok: false;
  error: string;
};

export type PrinterStatusResult = PrinterStatusOk | PrinterStatusErr;

export type CashDriversStatus = {
  coin: CashDriverStatusResult;
  note: CashDriverStatusResult;
  printer: PrinterStatusResult;
};

export function useCashDriversStatus({ enabled }: { enabled: boolean }) {
  return useQuery({
    queryKey: ["cash-drivers-status"],
    queryFn: async (): Promise<CashDriversStatus> => {
      const res = await fetch(
        `${getCashAgentUrl()}/debug/cash-drivers-status`,
      );
      if (!res.ok) throw new Error("cash drivers status fetch failed");
      return await res.json();
    },
    enabled,
    refetchInterval: 1000,
    refetchIntervalInBackground: false,
    staleTime: 0,
  });
}
